import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestAttachment from './ServiceRequestAttachment'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'registration-information/attachment',
    name:
        'serviceRequest.registration-information.attachment',
    component: ServiceRequestAttachment,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
